module.exports = __webpack_public_path__ + "static/media/reception6.3a25dd72.jpg";